import React, { useState } from 'react';
import { useConfigStore } from '../../store/configStore';

export const SettingsTab: React.FC = () => {
  const { config, updateSetting } = useConfigStore();
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [selectedOrder, setSelectedOrder] = useState(config.navigationOrder);

  const handleSave = async () => {
    setIsSaving(true);
    setSaveStatus('idle');

    try {
      await updateSetting('navigation_order', selectedOrder);
      setSaveStatus('success');
      setTimeout(() => setSaveStatus('idle'), 3000);
    } catch (error) {
      console.error('Failed to save setting:', error);
      setSaveStatus('error');
      setTimeout(() => setSaveStatus('idle'), 3000);
    } finally {
      setIsSaving(false);
    }
  };

  const hasChanges = selectedOrder !== config.navigationOrder;

  return (
    <div>
      <h2 style={{ marginBottom: '24px' }}>Application Settings</h2>

      <div
        style={{
          background: 'var(--bg-secondary)',
          padding: '24px',
          borderRadius: '8px',
          border: '1px solid var(--border)',
          marginBottom: '24px',
        }}
      >
        <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>Navigation Panel</h3>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '12px', color: 'var(--text-secondary)', fontSize: '14px' }}>
            Item Order
          </label>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px',
                background: 'var(--bg-tertiary)',
                borderRadius: '6px',
                cursor: 'pointer',
                border: selectedOrder === 'folders_first' ? '2px solid var(--accent)' : '2px solid transparent',
              }}
            >
              <input
                type="radio"
                name="navigationOrder"
                value="folders_first"
                checked={selectedOrder === 'folders_first'}
                onChange={(e) => setSelectedOrder(e.target.value as any)}
                style={{ marginRight: '12px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: 500, marginBottom: '4px' }}>Folders First (Default)</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                  Display folders before documents in the navigation panel
                </div>
              </div>
            </label>

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px',
                background: 'var(--bg-tertiary)',
                borderRadius: '6px',
                cursor: 'pointer',
                border: selectedOrder === 'documents_first' ? '2px solid var(--accent)' : '2px solid transparent',
              }}
            >
              <input
                type="radio"
                name="navigationOrder"
                value="documents_first"
                checked={selectedOrder === 'documents_first'}
                onChange={(e) => setSelectedOrder(e.target.value as any)}
                style={{ marginRight: '12px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ fontWeight: 500, marginBottom: '4px' }}>Documents First</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                  Display documents before folders in the navigation panel
                </div>
              </div>
            </label>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            onClick={handleSave}
            disabled={!hasChanges || isSaving}
            style={{
              padding: '10px 20px',
              borderRadius: '6px',
              background: hasChanges && !isSaving ? 'var(--accent)' : 'var(--bg-tertiary)',
              color: hasChanges && !isSaving ? 'white' : 'var(--text-secondary)',
              fontWeight: 500,
              cursor: hasChanges && !isSaving ? 'pointer' : 'not-allowed',
              opacity: hasChanges && !isSaving ? 1 : 0.6,
            }}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button>

          {saveStatus === 'success' && (
            <span style={{ color: 'var(--success, #10b981)', fontSize: '14px' }}>
              Settings saved successfully!
            </span>
          )}
          
          {saveStatus === 'error' && (
            <span style={{ color: 'var(--error)', fontSize: '14px' }}>
              Failed to save settings. Please try again.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
